module.exports = __webpack_public_path__ + "static/media/CommunityDetails2Screen_elMemoryCare1bdrmFeeUserPic_1062742123.5701cdc1.jpg";